module.exports = __webpack_public_path__ + "img/mortgage-mob-img.cec3672f.jpg";